
export function transformPercent (value, toClean) {
  if (toClean) {
    let cleanedValue = value.replace(/\s%/, '')
    if (/\s$/.test(cleanedValue)) {
      return cleanedValue.slice(0, -2)
    }
    return cleanedValue
  } else {
    return `${value} %`
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/percent.js